(function () {
  'use strict';

  function getSelectedVariantId() {
    var form =
      document.querySelector('form.product-form:not(.cart-bar__form)') ||
      document.querySelector('form.product-form, form[data-product-form]');

    // Prefer FE sync's owned hidden id (select[name=id] is demoted on purpose)
    if (form) {
      var fe = form.querySelector('input[data-fe-variant-id]');
      if (fe && fe.value) return fe.value;
      var checked = form.querySelector(
        '.custom-variant-input:checked, input[data-single-option-selector][type="radio"]:checked'
      );
      if (checked && checked.getAttribute('data-variant-id')) {
        return checked.getAttribute('data-variant-id');
      }
    }

    var select = document.querySelector('[data-product-select]');
    if (select && select.value) return select.value;

    if (!form) return null;
    select = form.querySelector('[name="id"]');
    return select && select.value ? select.value : null;
  }

  function syncBssVariantPrice() {
    if (typeof BSS_B2B === 'undefined') return;

    var productPrice = document.querySelector('[bss-b2b-featured-product]');
    if (!productPrice) return;

    var variantId = getSelectedVariantId();
    if (!variantId) return;

    productPrice.removeAttribute('bss-b2b-product-active');
    productPrice.setAttribute('bss-b2b-variant-id', variantId);

    if (typeof BSS_B2B.changeProductPriceWithInterval === 'function') {
      BSS_B2B.changeProductPriceWithInterval();
    }
  }

  var timer;
  function scheduleSync() {
    clearTimeout(timer);
    timer = window.setTimeout(syncBssVariantPrice, 150);
  }

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('[data-product-select], .custom-variant-input, [data-single-option-selector]')
    ) {
      scheduleSync();
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('.custom-variant__button-label, .custom-variant-input')) {
      scheduleSync();
    }
  });

  if (window.jQuery) {
    jQuery(document).on('variantChange variantPriceChange', scheduleSync);
  }

  /**
   * BSS B2B injects CSS that hides Shopify accelerated checkout wallets.
   * Restore them for non-B2B shoppers so Shop Pay / PayPal / Apple Pay work.
   */
  function isB2bCustomer() {
    if (document.body && document.body.classList.contains('fe-is-b2b')) return true;
    try {
      var tags = window.__feCustomerTags;
      if (!tags || !tags.length) return false;
      return tags.some(function (tag) {
        var t = String(tag || '').toLowerCase();
        // Canonical: wholesaler + intercompany. Legacy: wholesale*, company, compania, b2b
        return (
          t === 'wholesaler' ||
          t === 'intercompany' ||
          t === 'wholesale' ||
          t === 'company' ||
          t === 'compania' ||
          t.indexOf('wholesale') !== -1 ||
          t.indexOf('intercompany') !== -1 ||
          t.indexOf('b2b') !== -1
        );
      });
    } catch (e) {
      return false;
    }
  }

  function restoreAcceleratedCheckout() {
    if (isB2bCustomer()) return;

    if (!document.getElementById('fe-accelerated-checkout-js-restore')) {
      var style = document.createElement('style');
      style.id = 'fe-accelerated-checkout-js-restore';
      style.textContent = [
        '.shopify-payment-button,',
        '.shopify-payment-button__button,',
        '.shopify-payment-button__more-options,',
        'shopify-accelerated-checkout,',
        'shopify-accelerated-checkout-cart,',
        'shopify-accelerated-checkout-cart .wallet-cart-button {',
        '  display: block !important;',
        '  visibility: visible !important;',
        '  opacity: 1 !important;',
        '  pointer-events: auto !important;',
        '}',
        '.bss-b2b-btn-buyitnow { display: none !important; }'
      ].join('\n');
      document.head.appendChild(style);
    }

    try {
      if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
        Shopify.PaymentButton.init();
      }
    } catch (e) {}
  }

  function runRestore() {
    restoreAcceleratedCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runRestore);
  } else {
    runRestore();
  }
  window.addEventListener('load', function () {
    runRestore();
    window.setTimeout(runRestore, 500);
    window.setTimeout(runRestore, 1500);
  });
  document.addEventListener('cart:refresh', runRestore);
})();
